import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-24 sm:py-32 overflow-hidden bg-[#060C18]">
      {/* Central glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 65% 65% at 50% 50%, rgba(21,69,202,0.18) 0%, transparent 70%)",
        }}
      />

      {/* Grid */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `linear-gradient(rgba(21,69,202,0.04) 1px, transparent 1px),
                            linear-gradient(90deg, rgba(21,69,202,0.04) 1px, transparent 1px)`,
          backgroundSize: "64px 64px",
        }}
      />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-royal-500/10 border border-royal-500/20 text-royal-300 text-xs font-medium tracking-[0.1em] uppercase mb-8">
            Get Started
          </div>

          <h2
            className="text-white font-semibold tracking-tight leading-tight mb-5"
            style={{ fontSize: "clamp(2rem, 4vw, 3.2rem)" }}
          >
            Bring verification to your next procedure
          </h2>

          <p className="text-slate-400 text-lg leading-relaxed mb-10 max-w-xl mx-auto">
            Graft Counter is available for clinics and patients seeking objective
            post-operative documentation and professional reporting.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={() => navigate("/gc-about")}
              className="group flex items-center gap-2 px-8 py-4 bg-royal-600 hover:bg-royal-500 text-white rounded-xl font-medium transition-all duration-200"
              style={{ boxShadow: "0 0 40px rgba(21,69,202,0.4)" }}
            >
              Get Started
              <ArrowRight
                size={15}
                className="group-hover:translate-x-0.5 transition-transform"
              />
            </motion.button>

            <a
              href="mailto:info@graftcounter.app"
              className="flex items-center gap-2 px-8 py-4 bg-white/5 hover:bg-white/10 text-white border border-white/15 hover:border-white/25 rounded-xl font-medium text-sm transition-all duration-200"
            >
              <Mail size={14} />
              Contact Us
            </a>
          </div>

          <p className="text-slate-600 text-sm mt-8">
            Reach us at{" "}
            <a
              href="mailto:info@graftcounter.app"
              className="text-royal-400 hover:text-royal-300 transition-colors"
            >
              info@graftcounter.app
            </a>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
